// 华龙酸菜商户 - 旧版产品ID映射配置
// 用途：将旧版 product=35 映射到新版 product_id=uuid
// 部署域名：h5-hualong.vdvq.com

// 旧版产品ID到新版UUID的映射表
export const LEGACY_PRODUCT_MAPPING = {
  35: '32951447-b991-4a49-be62-24675aeab77a', // 净酸菜（238g）
  36: 'f28ecbe6-01bf-49e2-8066-f760b1bc83b5', // 酸菜脆笋（80g）
  37: '22b0d765-3302-4076-94b2-a32f55c7768b', // 酸菜香菇原味（80g）
  38: '35809ac6-afa8-46f0-a6b8-c62a4fc3f316', // 酸菜牛肉酱香辣（80g）
  39: '210a751f-ab97-45ac-ad19-7253af046a84', // 酸菜牛肉酱原味（80g）
  40: '66150aef-0b6c-4087-b179-7678303b6831', // 酸菜香菇牛肉酱原味（80g / 袋）
  41: '0f2ba887-948c-4464-92f2-7689413f7f56', // 酸菜牛肉酱香辣（230g / 瓶）
  42: '77456726-c5c0-4b3c-9802-0905cd615382', // 酸菜牛肉酱原味（230g / 瓶）
}

// 产品名称映射（用于日志和调试）
export const LEGACY_PRODUCT_NAMES = {
  35: '净酸菜（238g）',
  36: '酸菜脆笋（80g）',
  37: '酸菜香菇原味（80g）',
  38: '酸菜牛肉酱香辣（80g）',
  39: '酸菜牛肉酱原味（80g）',
  40: '酸菜香菇牛肉酱原味（80g / 袋）',
  41: '酸菜牛肉酱香辣（230g / 瓶）',
  42: '酸菜牛肉酱原味（230g / 瓶）',
}

/**
 * 解析URL中的产品参数，自动处理旧版ID映射
 * @returns {string|null} 返回新版UUID格式的product_id，失败返回null
 */
export function parseProductId() {
  const urlParams = new URLSearchParams(window.location.search)

  // 情况1：新版URL直接传了 product_id（UUID）
  const newProductId = urlParams.get('product_id')
  if (newProductId) {
    console.log('[产品ID] 使用新版参数:', newProductId)
    return newProductId
  }

  // 情况2：旧版URL传了 product（整数ID）
  const legacyProduct = urlParams.get('product')
  if (legacyProduct) {
    const legacyId = parseInt(legacyProduct)
    const mappedUUID = LEGACY_PRODUCT_MAPPING[legacyId]

    if (mappedUUID) {
      console.log(`[产品ID] 旧版参数映射: product=${legacyId} (${LEGACY_PRODUCT_NAMES[legacyId]}) -> ${mappedUUID}`)
      return mappedUUID
    } else {
      console.warn(`[产品ID] 旧版参数未找到映射: product=${legacyProduct}`)
      return null
    }
  }

  // 情况3：兼容旧版直接从URL路径提取（如果有的话）
  const url = window.location.href
  const match = url.match(/[?&]product=(\d+)/)
  if (match) {
    const legacyId = parseInt(match[1])
    const mappedUUID = LEGACY_PRODUCT_MAPPING[legacyId]
    if (mappedUUID) {
      console.log(`[产品ID] 从URL提取旧版参数: product=${legacyId} -> ${mappedUUID}`)
      return mappedUUID
    }
  }

  console.error('[产品ID] 未找到有效的产品参数')
  return null
}

/**
 * 检查是否是旧版产品ID
 * @param {string|number} productId
 * @returns {boolean}
 */
export function isLegacyProductId(productId) {
  const id = parseInt(productId)
  return !isNaN(id) && id in LEGACY_PRODUCT_MAPPING
}

/**
 * 获取产品名称（如果是旧版ID）
 * @param {string|number} productId
 * @returns {string|null}
 */
export function getLegacyProductName(productId) {
  const id = parseInt(productId)
  return LEGACY_PRODUCT_NAMES[id] || null
}
